import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from '../context/AuthContext';
import GoogleButton from '../components/GoogleButton';
import "./LoginNRegister.css";

export default function Register({ translations }) {
    const { register, user } = useAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    if (user) {
        navigate('/', { replace: true });
        return null;
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (password !== confirmPassword) {
            setError(translations['error-different-password']);
            return;
        }
        if (password.length < 8) {
            setError(translations['error-length-password']);
            return;
        }

        setLoading(true);
        try {
            await register(email, password, username);
            navigate('/verify', { state: { email } });
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            <div className="background-modal"></div>
            <div className="content">
                <h2>{translations['register-title']}</h2>
                <div className='inputs'>
                    <input 
                        type='text' 
                        value={username} 
                        onChange={(e) => setUsername(e.target.value)} 
                        placeholder={translations['username-placeholder']} 
                        className='input-text' 
                        minLength={3} 
                        maxLength={30} 
                        required
                    />
                    <input 
                        type='email'
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder={translations['email-placeholder']}
                        className='input-text'
                        required
                    />
                    <input
                        type='password'
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder={translations['password-placeholder']}
                        className='input-text'
                        minLength={8}
                        required
                    />
                    <input
                        type='password'
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        placeholder={translations['confirm-password-placeholder']}
                        className='input-text'
                        minLength={8}
                        required
                    />
                </div>
                {error && <p className="error-text">{error}</p>}
                <button className='btn register' onClick={handleSubmit} disabled={loading}>
                    {loading ? <span className="spinner" /> : translations['register-button']}
                </button>
                <GoogleButton translations={translations} />
                <div id="registerResult"></div>
            </div>
        </>
    );
}
